import { Descriptions, Empty, Timeline, Tooltip } from 'antd';
import dayjs from 'dayjs';
import React, { HTMLAttributes, useState } from 'react';
import { RiArrowDropDownFill, RiArrowDropRightFill } from 'react-icons/ri';
import SlideDown from 'react-slidedown';
import { camelCaseToWord } from '../../utils/strings';
import { JobStatusChangeLogView } from '../dashboard/candidates/job-status-changelog-view';
import { useTheme } from 'styled-components';

export const JobStatusHistory: React.FC<HTMLAttributes<HTMLDivElement> & { jobs: any[] }> = ({
	jobs,
	...restProps
}) => {
	const theme = useTheme();

	const [visibleAppLogs, setVisibleAppLogs] = useState({});
	const toggleAppVisibleLogs = id => setVisibleAppLogs({ ...visibleAppLogs, [id]: !visibleAppLogs[id] });
	return (
		<div>
			{jobs.length ? (
				<Timeline mode="left">
					{jobs.map(job => (
						<Timeline.Item className="mb-2" key={job.id}>
							<div className="d-flex justify-content-between">
								<Tooltip title={dayjs(job.createdAt).fromNow()}>
									<span className="text-muted">posted:</span>{' '}
									{dayjs(job.createdAt).format('ddd, MMM D, YYYY h:mm A')}
								</Tooltip>
							</div>
							<Descriptions layout="horizontal" column={{ xs: 1, md: 2 }} className="mt-2" size="small">
								<Descriptions.Item label="Current state">
									{camelCaseToWord(job.status)}
								</Descriptions.Item>

								<br />
							</Descriptions>
							<span
								style={{ cursor: 'pointer', color: theme.TA_GREEN }}
								onClick={e => toggleAppVisibleLogs(job.id)}
							>
								{visibleAppLogs[job.id] ? (
									<RiArrowDropDownFill size={24} />
								) : (
									<RiArrowDropRightFill size={24} />
								)}
								view full changelog
							</span>
							<SlideDown>{visibleAppLogs[job.id] && <JobStatusChangeLogView job={job} />}</SlideDown>
						</Timeline.Item>
					))}
				</Timeline>
			) : (
				<Empty />
			)}
		</div>
	);
};
